"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewTitle = void 0;
var image_button_1 = require("../../components/button/image.button");
var collection_title_1 = require("../../components/collection/collection.title");
var icons_1 = require("../../components/icon/icons");
var spinner_1 = require("../../components/spinner/spinner");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var photomeasure_button_1 = require("../photomeasure.button/photomeasure.button");
var collection_view_style_1 = require("./collection.view.style");
var CollectionEditViewTitle = /** @class */ (function () {
    function CollectionEditViewTitle() {
    }
    CollectionEditViewTitle.view = function (ctrl) {
        var actions;
        if (ctrl.isEditing) {
            actions = CollectionEditViewTitle.viewTitleEditActions(ctrl);
        }
        else {
            actions = CollectionEditViewTitle.viewTitleViewActions(ctrl);
        }
        // Create the default set of buttons
        var buttons = [
            CollectionEditViewTitle.viewButtonExpand(ctrl),
            CollectionEditViewTitle.viewButtonMetadata(ctrl),
            CollectionEditViewTitle.viewButtonZoomWindow(ctrl)
        ];
        // If we are in the Topological Editor, then we need to add the carousel toggle button
        if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
            buttons.push(CollectionEditViewTitle.viewCarouselButton(ctrl));
            // If the carousel is the element that is showing, then we dont want to show the form expand & contract button as it is not needed
            if (ctrl.isCarouselShown) {
                buttons.shift();
            }
        }
        var collection = ctrl.collection;
        var title = collection.title || collection.subtitle;
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.title.container }, [
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.title.tools }, actions),
            (0, mithril_1.m)('a', {
                className: 'mdl-button ' + collection_view_style_1.CSS.title.title,
                onclick: ctrl.zoomToCollection
            }, collection_title_1.CollectionTitle.view(title)),
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.title.tools }, buttons)
        ]);
    };
    CollectionEditViewTitle.viewButtonExpand = function (ctrl) {
        if (ctrl.isAllExpanded) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.KEY_DOWN, { onclick: ctrl.toggleExpandAll, title: i18n_1.T.COLLECTION_COLLAPSE_ALL });
        }
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.KEY_UP, { onclick: ctrl.toggleExpandAll, title: i18n_1.T.COLLECTION_EXPAND_ALL });
    };
    CollectionEditViewTitle.viewButtonMetadata = function (ctrl) {
        if (ctrl.isMetadataShown) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.INFO, { onclick: ctrl.toggleMetaInfo, title: i18n_1.T.COLLECTION_SHOW_META });
        }
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.INFO_FILLED, { onclick: ctrl.toggleMetaInfo, title: i18n_1.T.COLLECTION_SHOW_META });
    };
    CollectionEditViewTitle.viewCarouselButton = function (ctrl) {
        var title = ctrl.isCarouselShown ? i18n_1.T.TOPO_SHOW_COLLECTION_DATA : i18n_1.T.TOPO_SHOW_CAROUSEL;
        var icon = ctrl.isCarouselShown ? icons_1.MaterialIcon.CONTENT_PASTE : icons_1.MaterialIcon.FIELD_IMAGE;
        return image_button_1.ImageButton.view(icon, { onclick: ctrl.toggleCarousel, title: title });
    };
    CollectionEditViewTitle.viewButtonZoomWindow = function (ctrl) {
        if (!ctrl.isPhotomeasure) {
            return null;
        }
        var icon = ctrl.isZoomShown ? icons_1.MaterialIcon.GPS_ON : icons_1.MaterialIcon.GPS_OFF;
        return image_button_1.ImageButton.view(icon, { onclick: ctrl.toggleZoomWindow, title: i18n_1.T.COLLECTION_SHOW_ZOOM });
    };
    CollectionEditViewTitle.viewTitleEditActions = function (ctrl) {
        if (ctrl.isCollectionLoading || ctrl.isSaving) {
            return spinner_1.Spinner.view();
        }
        var userProfile = services_1.Services.UserProfile.get(services_1.Services.User.current.objectId);
        // if downloader or viewer the user, disable
        if (services_1.Services.UserProfile.isDepartmentDownloader(userProfile) || services_1.Services.UserProfile.isDepartmentViewer(userProfile)) {
            return [
                image_button_1.ImageButton.view(icons_1.MaterialIcon.CHECK, {
                    className: collection_view_style_1.CSS.title.save,
                    title: i18n_1.T.EXPORT_MENU_TITLE_PERMISSION,
                    disabled: true
                }),
                image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
                    title: i18n_1.T.COLLECTION_EDIT_ABORT,
                    onclick: ctrl.abortChanges
                })
            ];
        }
        var editState;
        if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
            editState = ctrl.collectionEditState;
        }
        if (ctrl.kind === 'CollectionEditCtrl') {
            editState = page_state_1.CurrentState.CollectionEdit;
        }
        return [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.CHECK, {
                className: collection_view_style_1.CSS.title.save,
                title: editState.isDirty ? i18n_1.T.COLLECTION_EDIT_SAVE_CHANGES : i18n_1.T.COLLECTION_EDIT_NO_CHANGES,
                disabled: !editState.isDirty || !ctrl.isValid,
                onclick: ctrl.saveChanges
            }),
            image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
                className: collection_view_style_1.CSS.title.discard,
                title: i18n_1.T.COLLECTION_EDIT_ABORT,
                disabled: !editState.isDirty || !ctrl.isValid,
                onclick: ctrl.abortChanges
            })
        ];
    };
    CollectionEditViewTitle.viewTitleViewActions = function (ctrl) {
        var collection = ctrl.collection;
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.title.tools }, [
            photomeasure_button_1.PhotomeasureButton.view(collection.jobId, collection.uuid),
            ctrl.isEditable ? image_button_1.ImageButton.view(icons_1.MaterialIcon.EDIT, { onclick: ctrl.enterEditMode, title: i18n_1.T.COLLECTION_EDIT }) : null
        ]);
    };
    return CollectionEditViewTitle;
}());
exports.CollectionEditViewTitle = CollectionEditViewTitle;
//# sourceMappingURL=collection.view.title.js.map